export enum CountryGroup {
  ALL = 'all',
  EU = 'eu',
  EUROPE = 'europe',
  NATIONAL = 'national',
}
